export default function ComingSoon({ label }) {
  return (
    <div className="bg-surface-container-low rounded-xl p-6 flex flex-col items-center justify-center min-h-[120px] border border-dashed border-outline-variant/40">
      <span className="material-symbols-outlined text-3xl text-on-surface-variant/60 mb-2">construction</span>
      <p className="font-label text-[11px] text-on-surface-variant font-semibold uppercase tracking-[0.12em]">{label || 'Coming Soon'}</p>
    </div>
  );
}
